import { Link } from '@inertiajs/react'
import { BackofficeLayout } from '@/components/layout/BackofficeLayout'
import { Button } from '@/components/ui/button'
import { CheckCircle2, ArrowLeft } from 'lucide-react'

type LicenseRef = {
  id: string
  display_name: string
  type_name: string
}

type RecordRef = {
  id: string
}

type Completion = {
  id: string
  created_at: string
} | null

type Props = {
  license: LicenseRef
  record: RecordRef
  completion: Completion
}

export default function BackofficeLicenseRecordCompletionShow({ license, record, completion }: Props) {
  return (
    <BackofficeLayout
      title="Completion"
      breadcrumbs={[
        { label: 'Backoffice', href: '/backoffice/dashboard' },
        { label: 'Licenses', href: '/backoffice/licenses' },
        { label: license.display_name, href: `/backoffice/licenses/${license.id}` },
        { label: 'Record', href: `/backoffice/licenses/${license.id}/records/${record.id}` },
        { label: 'Completion' },
      ]}
    >
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">Completion</h1>
          <p className="text-sm text-muted-foreground">{license.display_name}</p>
        </div>

        <section className="border rounded-lg">
          <div className="px-4 py-3 border-b">
            <h2 className="text-sm font-medium text-foreground">License Period Status</h2>
          </div>
          <div className="px-4 py-3">
            {completion ? (
              <div className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                  <span className="text-sm font-medium text-green-600">Completed</span>
                </div>
                <div className="flex justify-between text-sm mt-2">
                  <span className="text-muted-foreground">Completed on</span>
                  <span>{new Date(completion.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground text-center py-4">Not yet completed</p>
            )}
          </div>
        </section>

        <div>
          <Button variant="outline" asChild>
            <Link href={`/backoffice/licenses/${license.id}/records/${record.id}`}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Record
            </Link>
          </Button>
        </div>
      </div>
    </BackofficeLayout>
  )
}
